module.exports = __webpack_public_path__ + "img/mini.d061adac.jpg";